'use client';

import React from 'react';

import { Env, EnvContext } from '@flipster/utils/env';
import { getServerEnv } from '@flipster/utils/env-helper';

const env: Env = {
  NODE_ENV: process.env.NODE_ENV as 'development' | 'production',
  NEXT_PUBLIC_COMMIT_HASH: process.env.NEXT_PUBLIC_COMMIT_HASH || '',
  NEXT_PUBLIC_VERSION: process.env.NEXTs_PUBLIC_VERSION || '',
  NEXT_PUBLIC_SERVER_URL: process.env.NEXT_PUBLIC_SERVER_URL || '',
  AMPLITUDE_DEPLOYMENT_KEY:
    getServerEnv() === 'prod' ? 'client-7723FQQPPHMwjPjj8BRoW6SwdWvqlUnX' : 'client-tHI1DHZFHrHnDDp30HUZ73Euz2HTjCNR',
};

const EnvProvider = ({ children }: React.PropsWithChildren) => {
  return <EnvContext value={env}>{children}</EnvContext>;
};

export default EnvProvider;
